// extracted by mini-css-extract-plugin
export var date = "PressArticleCard-module--date--7a593";
export var icon = "PressArticleCard-module--icon--75a43";
export var iconContainer = "PressArticleCard-module--iconContainer--e9881";
export var learnMore = "PressArticleCard-module--learnMore--4b67e";
export var pressCardArticle = "PressArticleCard-module--pressCardArticle--b569e";
export var pressCardArticleContainer = "PressArticleCard-module--pressCardArticleContainer--2b01f";
export var pressContent = "PressArticleCard-module--pressContent--3ba02";
export var pressDate = "PressArticleCard-module--pressDate--d43ca";
export var pressImg = "PressArticleCard-module--pressImg--49576";